import { generatePath } from 'react-router-dom';

import _ from 'lodash';

import { LinkButton } from 'commonComponents/LinkButton';

import { CreateIcon } from 'icons/CreateIcon';
import { ROLE_DEFINITIONS } from 'roles/definitions';
import { RoleDependentComponent } from 'roles/RoleDependentComponent';
import { ROUTES } from 'routes/routes';

export function LicenseUpgradeButton({ licenseDetails }) {
    const isActivated = !!licenseDetails.activeLicenseFilesCount;
    const hasSerialNumber = !_.isEmpty(licenseDetails?.serial_number);
    if (isActivated && hasSerialNumber) {
        return (
            <RoleDependentComponent
                userRole={ROLE_DEFINITIONS.PrivilegedCustomer}
                component={LinkButton}
                color="secondary"
                iconClass={CreateIcon}
                route={generatePath(ROUTES.LICENSE_UPGRADE, { id: licenseDetails.id })}
                title="Upgrade"
            />
        );
    }

    return null;
}
